import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=2b79da7b"
import script from "./InputMask.vue?vue&type=script&lang=js"
export * from "./InputMask.vue?vue&type=script&lang=js"
import style0 from "./InputMask.vue?vue&type=style&index=0&id=2b79da7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports